import { cn, Label, type LabelProps } from '@seen/ui'
import type { ElementRef } from 'react'
import { useFormField } from '#src/hooks/useFormField.ts'
import { forwardRef } from '#src/utils/forwardRef.ts'

export type FormLabelProps = Omit<LabelProps, 'id'>

export const FormLabel = forwardRef<ElementRef<typeof Label>, FormLabelProps>(
  ({ className, ...props }, ref) => {
    const { error, formItemId } = useFormField()

    return (
      <Label
        ref={ref}
        className={cn(error && 'text-destructive', className)}
        htmlFor={formItemId}
        {...props}
      />
    )
  }
)
